import React from 'react';
import { Link } from 'react-router';
import { startCase, toLower } from 'lodash';
import { Button } from '@unite-us/app-components';
import { CardDetail } from 'src/common/Card';

const getClientName = ({
  isCBOProvider,
  hbh1509ClientsDrawerP2Enabled,
  clientData,
  onClick,
  invoice,
}) => {
  if (isCBOProvider) {
    if (hbh1509ClientsDrawerP2Enabled && clientData) {
      return (
        <CardDetail label="Client Name">
          <Button
            className="m-0 text-sm text-brand-blue hover:underline hover:text-action-blue pl-0 pt-0 pb-0 font-semibold"
            link
            onClick={() => onClick(true)}
            label={clientData.full_name}
            omitDefaultStyles
          />
        </CardDetail>
      );
    }

    return (
      <CardDetail label="Client Name">
        <Link
          className="text-action-blue"
          to={`/facesheet/${invoice.client_id}`}
          data-testid="invoice-details-page-facesheet-link"
        >
          {startCase(toLower(invoice.client_name))}
        </Link>
      </CardDetail>
    );
    }

  return <CardDetail label="Client Name">{startCase(toLower(invoice.client_name))}</CardDetail>;
};

export default getClientName;
